import { render, staticRenderFns } from "./detailVideo.vue?vue&type=template&id=1de3aeba&scoped=true"
import script from "./detailVideo.vue?vue&type=script&lang=js"
export * from "./detailVideo.vue?vue&type=script&lang=js"
import style0 from "./detailVideo.vue?vue&type=style&index=0&id=1de3aeba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de3aeba",
  null
  
)

export default component.exports